import { IconButton } from '@cambridgeassessment/cambridge-ui';
import { FormControl, Input, InputAdornment } from '@material-ui/core';
import { CloseRounded, SearchOutlined } from '@material-ui/icons';
import React, { memo, useCallback, useRef } from 'react';
import { useStyles } from './styles';

export interface Props {
  searchQuery: string;
  placeholder?: string;
  onSubmit: (value?: string) => void;
  onChange: (value?: string) => void;
}

const SearchField: React.FC<Props> = ({
  searchQuery,
  placeholder = '',
  onSubmit,
  onChange,
}) => {
  const classes = useStyles();
  const inputRef = useRef(null);

  const handleChange = useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleSubmit = useCallback(() => {
    inputRef.current.focus();
    onSubmit(searchQuery);
  }, [onSubmit, searchQuery]);

  const handleReset = useCallback(() => {
    inputRef.current.focus();
    onSubmit('');
  }, [onSubmit]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        handleSubmit();
      }
    },
    [handleSubmit]
  );

  return (
    <FormControl className={classes.container}>
      <Input
        inputRef={inputRef}
        autoComplete="off"
        data-testid="search-input"
        className={classes.input}
        disableUnderline
        placeholder={placeholder}
        startAdornment={
          <InputAdornment
            position="start"
            onClick={handleSubmit}
            className={classes.startAdornment}
          >
            <SearchOutlined className={classes.searchIcon} />
          </InputAdornment>
        }
        value={searchQuery}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        endAdornment={
          <>
            {searchQuery && (
              <IconButton
                className={classes.closeIcon}
                onClick={handleReset}
                size="small"
                data-testid="search-closeButton"
              >
                <CloseRounded />
              </IconButton>
            )}
          </>
        }
      />
    </FormControl>
  );
};

export default memo(SearchField);
